import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { API_URL } from "../ConstVariable";
const makeWorkdeskActive = () => {
    var element1 = document.getElementById("li_workdesk");
    element1.classList.add("active");
    var element2 = document.getElementById("li_callhistory");
    element2.classList.remove("active");
    var element3 = document.getElementById("li_trash");
    element3.classList.remove("active");
    var element4 = document.getElementById("li_stats");
    element4.classList.remove("active");
    var element5 = document.getElementById("li_manualOrder");
    element5.classList.remove("active");
    var element6 = document.getElementById("li_directCall");
    element6.classList.remove("active");
}

const Session = () => {
    if (document.getElementById("menu-bar"))
        document.getElementById("menu-bar").style.display = "none";

    const history = useHistory();
    const { getAccessTokenSilently } = useAuth0();


    const GetAuthToken = async () => {
        const token = await getAccessTokenSilently();
        return token;
    }

    const addTokenIfExists = (options) => {
        const idToken = GetAuthToken();
        if (idToken) {
            return {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${idToken}`,
                },
            };
        }
        return options;
    };

    useEffect(async () => {
        let token = await GetAuthToken();
        var form_data = new FormData();
        form_data.append("auth0_token", token);
        form_data.append("session_limit", 20);
        // let headers = { "Content-Type": "multipart/form-data", "Authorization": `Bearer ${token}` }
        // console.log("headers:", headers)
        let options = {
            method: "POST",
            url: `${API_URL}/session/v1/init`,
            headers: {
                "content-type": `multipart/form-data`,
            },
            withCredentials: true,
            data: form_data
        }

        if (token) {
            options = {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${token}`,
                },
                withCredentials: true
            };
        }
        console.log("options:", options)
        // options = addTokenIfExists(options);
        axios(options).then((response) => {
            document.getElementById("menu-bar").style.display = "block";
            makeWorkdeskActive();
            history.push(`/workdesk`)
        })
        // axios.post("http://localhost/session/v1/init", form_data,headers).then((response)=>{
        //     console.log("Session response:", response);
        //     // sendUserUtterance() 
        //     // document.getElementById("menu-bar").style.display = "block";
        //     // makeWorkdeskActive();
        //     // history.push(`/workdesk`)

        // }).catch((error)=>{
        //     console.error("Session error:", error);
        // })
    }, [])

    return (
        <div>Initializing Session</div>
    )
}

export default Session